import React, { useEffect, useState } from "react";
import toastr from "toastr";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEye } from "react-icons/fi";
import { Link } from "react-router-dom";
import { isUserSO } from "../IncidentManagement/Helper";
import {
  deleteEventSchedule,
  getAllEventSchedules,
} from "app/_services/ehs/ehsEventScheduleServices";
import {
  getOhseStatusClass,
  getStatus,
  getStatusClass,
  ohseFilterFields,
  tableFormat,
} from "./CONSTANT";
import { connect, useDispatch, useSelector } from "react-redux";

import BackBtn from "app/Components/CommanComponents/BackBtn";

// import { ProgressBar } from "react-bootstrap";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { MEETING_STATUS, MEETING_STATUS_VIEW } from "./CONSTANT";
import {
  DDMMYYYYFormat,
  DDMMYYYYHHMMAFormat,
  isBetween,
  YYYYMMDDFormat,
} from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import OHSEFilter from "./Component/OHSEFilter";
import { useForm } from "app/_helpers/hooks";
import { validateRowFilter } from "../IncidentManagement/CONSTANTS";
import { ACTIVE_MODULE, moduleType } from "app/_constants/constant";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import DeleteRecordIcon from "app/Components/DeleteRecordIcon/DeleteRecordIcon";

const ViewOHSE = ({
  user,
  match: {
    params: { siteId },
  },
}) => {
  //   const filterStatus = useSelector((state) => state.filterReducerTraining);
  //   const [searchFilter, setSearchFilter] = useState();

  const [tableData, setTableData] = useState([]);
  const [tableOHSEList, setTableOHSEList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, ohseFilterFields);

  //   const onSearchFilter = (props) => {
  //     let value = props?.searchProps?.searchText;
  //     if (searchFilter?.search !== props?.searchProps?.searchText) setSearchFilter(value);
  //   };

  const onReset = () => setFilterForm({});

  const fetchData = async () => {
    try {
      const response = await getAllEventSchedules();
      if (!response?.data) {
        // Handle the case where data is not received
        setLoading(false);
        return;
      }
      response.data = response.data.map((d) => {
        const data =
          d?.isExecuted == true
            ? d?.progressCompleteTask !== 0 && d?.progressTotalTask !== 0
              ? (Number(d?.progressCompleteTask / d?.progressTotalTask) * 100).toFixed(2)
              : "N/A"
            : "N/A";
        return { ...d, progressStatus: data };
      });
      setTableData(response?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error as needed, e.g., show an error message
      setLoading(false);
    }
  };

  useEffect(() => {
    // getAllEventSchedules().then((response) => {
    //   if (!response?.data) return;
    //   response.data = response.data.map((d) => {
    //     const data =
    //       d?.isExecuted == true
    //         ? d?.progressCompleteTask !== 0 && d?.progressTotalTask !== 0
    //           ? (Number(d?.progressCompleteTask / d?.progressTotalTask) * 100).toFixed(2)
    //           : "N/A"
    //         : "N/A";
    //     return { ...d, progressStatus: data };
    //   });
    //   setTableData(response?.data);
    // });
    fetchData();
  }, []);

  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "scheduleId",
      text: "OHSE Review ID",
      sort: true,
      formatter: (scheduleId, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        >
          <Link
            className="icons text-cyanBlue"
            to={
              (row?.eventStatus === MEETING_STATUS.draft ||
              row?.eventStatus === MEETING_STATUS.planned
                ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
              row?.id
            }
          >
            {scheduleId}
          </Link>
        </OverlayTrigger>
      ),
    },
    {
      dataField: "type",
      text: "Review Type",
      sort: true,
    },
    {
      dataField: "siteName",
      text: "Location",
      sort: true,
      //   formatter: (site) => `${site?.name}`,
    },
    {
      dataField: "venue",
      text: "Venue",
      sort: true,
    },
    {
      dataField: "date",
      text: "Review Date & Time",
      sort: true,
      formatter: (date) => DDMMYYYYHHMMAFormat(date),
    },
    {
      dataField: "progressStatus",
      text: "Progress",
      sort: true,
      formatter: (row, data) => {
        return (
          <>
            {data?.isExecuted == true ? (
              data?.progressCompleteTask !== 0 && data?.progressTotalTask !== 0 ? (
                <ProgressBar
                  bgcolor={"#333"}
                  completed={`${(
                    Number(data?.progressCompleteTask / data?.progressTotalTask) * 100
                  ).toFixed(2)}%`}
                />
              ) : (
                // <ProgressBar
                //   className="progress mb-3 mt-2"
                //   now={(
                //     Number(data?.progressCompleteTask / data?.progressTotalTask) * 100
                //   ).toFixed(2)}
                //   striped
                //   animated
                //   label={`${(
                //     Number(data?.progressCompleteTask / data?.progressTotalTask) * 100
                //   ).toFixed(2)}%`}
                //   variant="primary"
                // ></ProgressBar>
                "N/A"
              )
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      dataField: "eventStatusView",
      text: "Status",
      formatter: (status, row) => {
        return <div className={getOhseStatusClass(row?.eventStatus)}>{status}</div>;
      },
    },
    {
      dataField: "createdAt",
      text: "Time Stamp",
      sort: true,
      formatter: (createdAt, row) => {
        return DDMMYYYYHHMMAFormat(createdAt);
      },
    },
    {
      dataField: "id",
      text: "Action",
      formatter: (id, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Views</Tooltip>}
            >
              <Link
                to={
                  (row?.eventStatus === MEETING_STATUS.draft ||
                  row?.eventStatus === MEETING_STATUS.planned
                    ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                    : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
                  id
                }
                className="icons text-cyanBlue"
              >
                <FiEye />
              </Link>
            </OverlayTrigger>

            <DeleteRecordIcon
              id={row.id}
              moduleType={moduleType.ehsEventSchedule}
              setLoading={setLoading}
              reloadData={fetchData}
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setTableOHSEList(
      tableData?.filter?.((data) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            YYYYMMDDFormat(data.createdAt),
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, tableData]);
  console.log("tableData", tableData);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <OHSEFilter
        fields={ohseFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          { name: "View OHSE Reviews" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />
      <div>
        {/* <MainBreadcrumb routeSegments={[{ name: "Health Safety And Environment", path: "#" }, { name: "OHSE" }]} /> */}

        <div className="card p-4 mb-4 mt-4 EHS_module_create_form">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Views OHSE</h3>
            <FilterBtn setShowFilter={setShowFilter} />
            <BackBtn
              url={`${
                siteId ? `/sites/${siteId}` : ""
              }/health-safety-and-environment/audits-meetings`}
            />
          </div>
          {!loading ? (
            <SearchBootstrapTable
              searchKey={"viewOHSEDesktopSearch"}
              // data={tableOHSEList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
              data={tableOHSEList.map((d, idx) => {
                const progressPercentage =
                  d?.progressCompleteTask && d?.progressTotalTask
                    ? (
                        Number(d.progressCompleteTask / d.progressTotalTask) * 100
                      ).toFixed(2)
                    : "0";
                const progressStatus = progressPercentage.endsWith(".00")
                  ? progressPercentage.slice(0, -3) + "%"
                  : progressPercentage + "%";
                return { ...d, sid: idx + 1, progressStatus };
              })}
              columns={sortableColumn}
              tableBeforeSearch={tableToolbarBeforeView}
              //   tableToolbarView={tableToolbarView}
              // downloadPermission={"global_globalConfiguration_download"}
              tableKey="viewOHSE"
              defaultHideColumn={["venue"]}
            />
          ) : (
            <NetZeroLoader />
          )}
        </div>
      </div>
    </>
  );
};

export default connect((state) => ({ user: state.user.user }))(ViewOHSE);

const ProgressBar = (props) => {
  const { completed } = props;

  const containerStyles = {
    height: 24,
    width: "100%",
    backgroundColor: "rgb(169, 169, 163)",
    borderRadius: 5,
    textAlign: "center",
    position: "relative",
  };

  const fillerStyles = {
    height: "100%",
    width: `${completed}`,
    backgroundColor: "#00bcd4",
    borderRadius: "inherit",
    top: "0",
    position: "absolute",
  };

  const labelStyles = {
    zIndex: "99",
    color: "white",
    fontWeight: "500",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    height: "100%",
  };

  return (
    <div className="progressBarBg" style={containerStyles}>
      <span style={labelStyles}>{`${completed}`}</span>
      <div style={fillerStyles}></div>
    </div>
  );
};
